var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('b-modal',{attrs:{"centered":"","cancel-disabled":"","hide-footer":"","title":`Visualização da descrição curta - ${_vm.productName}`,"size":"lg"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.shortDescription)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }